module.exports = __webpack_public_path__ + "img/shangxianqian.3668977e.png";